<template>
  <div class="dakoku">
    <loading v-if="!isInit"></loading>
    <template v-else>
      <div class="baseinfo">

        <div class="search-area">

          <div class="period-selecter">
            <b>勤務年月</b>
            <month-picker v-model="yearMonthForMonthPicker" @update:modelValue="changeMonth" :disabled="isLoading"
              :clearable=false></month-picker>
          </div>

          <div class="period-selecter">
            <b>就業場所</b>
            <select-box :hasBlank="true" :options="syuugyouBasyoOptions" v-model="selectedSyuugyouBasyo"
              :disabled="isLoading"></select-box>
          </div>

          <div class="period-selecter">
            <b>社員番号(カンマ区切りで複数指定)</b>
            <input-text v-model="staffCodes" :disabled="isLoading" style="padding:5px;"></input-text>
          </div>

          <div class="pager">
            <div class="period-selecter">
              <b>開始件数番号</b>
              <input-text v-model="startIndex" :disabled="isLoading" style="padding:5px;"></input-text>
            </div>

            <div class="period-selecter">
              <b>終了件数番号</b>
              <input-text v-model="endIndex" :disabled="isLoading" style="padding:5px;"></input-text>
            </div>

            <div class="period-selecter">
              <b>検索結果総件数</b>
              <p>{{totalDataCount}}件</p>
            </div>
          </div>

          <div class="period-selecter">
            <b>総務未確認のみ</b>
            <input-checkbox :options="OptionConst.NO_LABEL" v-model="isSoumuNotCheck"
              :disabled="isLoading"></input-checkbox>
          </div>

          <div class="period-selecter">
            <button type="button" class="btn info" @click="searchData" :disabled="isLoading">
              検索
            </button>
          </div>

          <div class="period-selecter">
            <button type="button" class="btn info" @click="clearSearchCondition" :disabled="isLoading">
              検索条件クリア
            </button>
          </div>
        </div>
        <hr>
      </div><!-- /baseinfo -->
      <loading v-if="isLoading"></loading>
      <p class="align-center" v-else-if="!myTaskList || myTaskList.length < 1">該当するデータがありません</p>
      <div class="maininfo" v-else-if="myTaskList.length >= 1">
        <div>
          <button type="button" class="btn success" @click="updateCheckListBySoumu"
            :disabled="selectItemCountBySoumu === 0">
            選択した{{ selectItemCountBySoumu }}件の総務チェックを登録する
          </button>
        </div>
        <div v-for="(data, key) in myTaskList" v-bind:key="key">
          <hr>
          <div class="userDisp" :id="'user' + data.user_id">
            <p><b>社員番号：</b>
              <template v-if="data.staff_code !== null">
                {{ data.staff_code }}
              </template>

              <template v-else>
                "未登録"
              </template>
            </p>
            <p><b>名前：</b>{{ data.staff_name }}</p>
            <p><b>就業場所：</b>{{ data.syuugyou_basyo_name }}</p>
            <p>{{ data.index }}/{{totalDataCount}}件目</p>

            <p class="p-btn">
              <button class="btn success"
                v-on:click="changeKinmuList(data.user_id, data.mst_syounin_group_id, data.mst_syuugyou_basyo_id, data.koyou_keiyaku_id)">タイムシートへ</button>
            </p>

            <p class="p-btn">

              <template v-if="data.is_haken === true">
                <button class="btn success" v-on:click="changeHakenList(data)">派遣先用編集へ</button>
              </template>
            </p>

          </div>

          <div>
            <button type="button" class="btn primary" @click="setDakokuCheckAllBySoumu(data)">
              一括で確認にチェックを入れる
            </button>
          </div>

          <div class="kinmu-table-wrapper">
            <table class="kinmu-table">
              <thead class="soumu-check-thead">
                <tr class="kinmu-table-header-row">
                  <th class="date">日付</th>
                  <th class="time">出勤<br />（打刻）</th>
                  <th class="time">外出<br />（打刻）</th>
                  <th class="time">戻り<br />（打刻）</th>
                  <th class="time">退勤<br />（打刻）</th>
                  <th class="time">休憩</th>
                  <th class="time">勤務<br />時間</th>
                  <th class="time">控除<br />時間</th>
                  <th class="time">法定内残業</th>
                  <th class="time">時間外</th>
                  <th class="time">深夜割増</th>
                  <th class="time">遅刻</th>
                  <th class="time">早退</th>
                  <!-- <th class="comment">本人コメント</th> -->
                  <th class="approve">承認</th>

                  <template v-if="data.is_haken === true">

                    <th class="haken comment">総務<br />編集1</th>
                    <th class="haken time">総務<br />編集2</th>
                    <th class="haken time">編集後<br />勤務<br />時間</th>

                  </template>

                  <!-- <th v-on:click="sortByIsKakunin">△確認▽</th> -->
                  <th class="check">確認</th>
                  <!-- <th>確認者</th> -->

                </tr>
              </thead>
              <tbody>

                <template v-for="item in data.list">
                  <template v-if="item.kinmus.length > 0">
                    <!-- <tr class="kinmu-table-data-row" :ref="(el: any) => { if (el) rows.push({ key: item.key, el: el }) }" -->
                    <tr class="kinmu-table-data-row" :class="{
      'is-approval': kinmu.syounin_status_type === OptionConst.DAKOKU_SYOUNIN_STATUS.APPROVED,
      'applying': item.waitShinseis.length > 0,
      'uncomplete': kinmu.isUncomplete,
      'need-kyuukei': kinmu.isNeedKyuukei,
      'soumu-syuusei': kinmu.soumu_change_user_id,
      'is-saishin': kinmu.is_saishin == false,
    }" v-for="(kinmu, index) in item.kinmus" :key="kinmu.dakoku_id">
                      <td class="date" v-if="index === 0" :rowspan="item.kinmus.length"
                        v-bind:class="{ 'color-red': item.date_for_display.substr(-2, 1) == '日' }">

                        {{ item.date_for_display }}

                        <shinseis-title :shinseis="item.shinseis" :kinmu="kinmu" :userId="data.user_id"  @clickShinsei="setStoreByClickShinsei"></shinseis-title>

                      </td>

                      <td class="syukkin time">
                        {{ timeFormat(kinmu.syukkin_round_datetime) }}
                        <span v-if="kinmu.syukkin_round_datetime"><br />
                          ({{ timeFormat(kinmu.syukkin_datetime) }})
                        </span>
                      </td>
                      <td class="gaisyutsu time">
                        {{ timeFormat(kinmu.gaisyutsu_round_datetime) }}
                        <span v-if="kinmu.gaisyutsu_round_datetime"><br />
                          ({{ timeFormat(kinmu.gaisyutsu_datetime) }})
                        </span>
                      </td>
                      <td class="modori time">
                        {{ timeFormat(kinmu.modori_round_datetime) }}
                        <span v-if="kinmu.modori_round_datetime"><br />
                          ({{ timeFormat(kinmu.modori_datetime) }})
                        </span>
                      </td>
                      <td class="taikin time">
                        {{ timeFormat(kinmu.taikin_round_datetime) }}
                        <span v-if="kinmu.taikin_datetime"><br />
                          ({{ timeFormat(kinmu.taikin_datetime) }})
                        </span>
                      </td>
                      <td class="kyuukei time">
                        {{ timeToHHmm(kinmu.kyuukei_round_times) }}
                        <span v-if="kinmu.kyuukei_times"><br />
                          ({{ timeToHHmm(kinmu.kyuukei_times) }})
                        </span>
                      </td>
                      <td class="syotei-work-time time">
                        {{ kinmu.syotei_work_times ? timeToHHmm(kinmu.syotei_work_times) : '00:00' }}
                      </td>
                      <td class="koujo-time time">
                        {{ kinmu.koujo_times ? timeToHHmm(kinmu.koujo_times) : '00:00' }}
                      </td>
                      <td class="houteinai-work-time time">
                        {{ kinmu.houteinai_zangyou_times ? timeToHHmm(kinmu.houteinai_zangyou_times) : '00:00' }}
                      </td>
                      <td class="jikangai-work-time time">
                        {{ kinmu.jikangai_work_times ? timeToHHmm(kinmu.jikangai_work_times) : '00:00' }}
                      </td>
                      <td class="shinya-warimashi-times time">
                        {{ kinmu.shinya_warimashi_times ? timeToHHmm(kinmu.shinya_warimashi_times) : '00:00' }}
                      </td>
                      <td class="chikoku-time time">
                        {{ kinmu.chikoku_times ? timeToHHmm(kinmu.chikoku_times) : '00:00' }}
                      </td>
                      <td class="soutai-time time">
                        {{ kinmu.soutai_times ? timeToHHmm(kinmu.soutai_times) : '00:00' }}
                      </td>
                      <!-- <td class="honnin-notes comment">
                      <div class="pre">{{ kinmu.honnin_notes }}</div>
                    </td> -->
                      <td class="approve">

                        <!-- icon -->
                        <!-- <div class="icon-container"> -->

                        <template v-if="kinmu.syounin_status_type === OptionConst.SYOUNIN_STATUS.WAIT">
                          <div class="icon">
                            <img :src="Const.SYOUNIN_STATUS_WAIT_ICON_PATH">
                          </div>
                        </template>

                        <template v-if="kinmu.syounin_status_type === OptionConst.SYOUNIN_STATUS.APPROVED">
                          <div class="icon">
                            <img :src="Const.SYOUNIN_STATUS_APPROVED_ICON_PATH">
                          </div>
                        </template>

                        <template v-if="kinmu.syounin_status_type === OptionConst.SYOUNIN_STATUS.DENIED">
                          <div class="icon">
                            <img :src="Const.SYOUNIN_STATUS_DENIED_ICON_PATH">
                          </div>
                        </template>

                        <!-- </div> -->
                        <!-- icon -->
                      </td>


                      <!--　総務表示用↓ -->
                      <!-- 派遣先向けの編集情報を表示 -->

                      <template v-if="data.is_haken === true">

                        <template v-if="item.haken.length > 0">
                          <td class="haken comment">{{ item.haken[0].soumu_note1 }}</td>
                          <td class="haken time">{{ item.haken[0].soumu_note2 }}</td>

                          <template v-if="item.haken[0].soumu_note1 != null || item.haken[0].soumu_note2 != null">
                            <td class="haken time">{{ item.haken[0].modifiedKinmuTimes }}</td>
                          </template>

                          <template v-else>
                            <td></td>
                          </template>

                        </template>

                        <template v-else>
                          <td></td>
                          <td></td>
                          <td></td>
                        </template>

                      </template>


                      <!-- 登録した確認を表示 -->

                      <template v-if="item.check.length > 0">
                        <td class="check"><label class="fas fa-check"></label></td>
                        <!-- <td>{{ item.check[0].checkedUserName }}</td> -->
                      </template>

                      <template v-else>
                        <td class="check">
                          <input-checkbox :options="OptionConst.NO_LABEL"
                            v-model="item.is_soumu_select"></input-checkbox>
                        </td>
                        <!-- <td></td> -->
                      </template>
                      <!--　総務表示用↑ -->

                    </tr>
                  </template>

                  <template v-else>
                    <!-- <tr class="none" :class="{ applying: item.waitShinseis.length > 0 }" :key="item.key"
                    :ref="(el: any) => { if (el) rows.push({ key: item.key, el: el }) }"> -->
                    <tr class="none" :class="{ applying: item.waitShinseis.length > 0 }" :key="item.key">
                      <td class="date" v-bind:class="{ 'color-red': item.date_for_display.substr(-2, 1) == '日' }">
                        {{ item.date_for_display }}

                        <shinseis-title :shinseis="item.shinseis" :kinmu="null" :userId="data.user_id" @clickShinsei="setStoreByClickShinsei"></shinseis-title>

                      </td>

                      <td class="syukkin time"></td>
                      <td class="gaisyutsu time"></td>
                      <td class="modori time"></td>
                      <td class="taikin time"></td>
                      <td class="kyuukei time"></td>
                      <td class="chikoku-time time"></td>
                      <td class="soutai-time time"></td>
                      <td class="koujo-time time"></td>
                      <td class="syotei-work-time time"></td>
                      <td class="houteinai-work-time time"></td>
                      <td class="jikangai-work-time time"></td>
                      <td class="shinya-warimashi-times time"></td>
                      <!-- <td class="honnin-notes comment"></td> -->
                      <td class="approve">-</td>

                      <!--　総務表示用↓ -->

                      <template v-if="data.is_haken === true">

                        <template v-if="item.haken.length > 0">
                          <td class="haken comment">{{ item.haken[0].soumu_note1 }}</td>
                          <td class="haken time">{{ item.haken[0].soumu_note2 }}</td>

                          <template v-if="item.haken[0].soumu_note1 != null || item.haken[0].soumu_note2 != null">
                            <td class="haken time">{{ item.haken[0].modifiedKinmuTimes }}</td>
                          </template>

                          <template v-else>
                            <td></td>
                          </template>

                        </template>

                        <template v-else>
                          <td></td>
                          <td></td>
                          <td></td>
                        </template>

                      </template>

                      <template v-if="item.check.length > 0">
                        <td class="check"><label class="fas fa-check"></label></td>
                        <!-- <td>{{ item.check[0].checkedUserName }}</td> -->
                      </template>

                      <template v-else>
                        <td class="check">
                          <input-checkbox :options="OptionConst.NO_LABEL"
                            v-model="item.is_soumu_select"></input-checkbox>
                        </td>
                        <!-- <td></td> -->
                      </template>
                      <!--　総務表示用↑ -->

                    </tr>
                  </template>
                </template>
              </tbody>
            </table>

          </div>


        </div>

      </div>
    </template>


  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, Ref, ref, computed, nextTick } from 'vue';
import { dateFormat, dateFormatMMDD, timeFormat, timeToHHmm } from "@/filters/common";
import { useAuthStore } from '@/store/auth';
import { useSoumuCheckUpdate } from '@/composable/mytask/soumucheck/update';
import { useSoumuCheckList } from '@/composable/mytask/soumucheck/list';
import DakokuDetail from "@/components/mytask/parts/DakokuDetail.vue";
import { useDakokuDetailModal } from '@/composable/modal/mytask-dakoku-detail';
import { MyTaskData, MyTaskSelectItem } from "@/types/Dakoku";
import { SoumuDakokuCheckParams, SoumuDakokuCheckRequest, SoumuDakokuCheckWhereConditions } from "@/types/MyTask";
import OptionConst from "@/const/Option";
import Const from '@/const/Shinsei/Option';
import { PermissionConst } from '@/const/Permission';
import { DialogService } from '@/service/DialogService';
import ShinseisTitle from '@/components/kinmu/ShinseisTitle.vue';
import { MonthPickerModelValue } from "@/components/form/MonthPicker.vue";
import { useSoumuCheckStore } from '@/store/mytask-soumu-check';
import { useRouter } from 'vue-router';
import { RouterConst } from "@/const/Router";
import { useRoute } from "vue-router";
import { useSyuugyouBasyoInit } from '@/composable/syuubyoubasyo/init';
import dayjs from "dayjs";
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { useMyTaskCommonStore } from '@/store/mytask-common';

export default defineComponent({
  // props: ['form', 'options', 'tab'],
  // props: ['options', 'tab'],
  setup(props) {

    const authStore = useAuthStore();

    // 初期化
    const { isUpdating, updateSoumuChecks } = useSoumuCheckUpdate();

    const { getDakokuSoumuCheckList, myTaskList, isListLoading, isListError, dakokuSyouninStatus, totalDataCount } = useSoumuCheckList();
    const { syuugyouBasyoOptions, getAllSyuugyouBasyoOptions } = useSyuugyouBasyoInit()

    const router = useRouter()

    const route = useRoute()

    const whereConditonStore = useSoumuCheckStore()
    const myTaskCommonStore = useMyTaskCommonStore()

    const isInit = ref(false)
    const rows: Ref<{ key: string, el: HTMLTableRowElement }[]> = ref([])

    const dakokuDetailModal = useDakokuDetailModal()

    const isLoading = ref(false)

    dayjs.extend(isSameOrAfter);

    // 検索条件
    let year = ref(new Date().getFullYear()) // 初期値として現在の西暦をセット
    let month = ref(new Date().getMonth() + 1) // 初期値として現在の月をセット
    const whereStartDate = ref<string>('')
    const whereEndDate = ref<string>('')
    const whereKana = ref<string>('')
    const whereSyuugyouBasyo = ref<string>('')
    const staffCodes = ref<string | null>('')
    const isSoumuNotCheck = ref<boolean>(false)
    const selectedSyuugyouBasyo: Ref<number | null> = ref(0)
    const startIndex: Ref<number | null> = ref(1) // ページャー開始件数
    const endIndex: Ref<number | null> = ref(20) // ページャー終了件数


    onMounted(async () => {
      isLoading.value = true
      await getAllSyuugyouBasyoOptions()

      let cond = whereConditonStore.searchItem

      // 年月が保存されていない場合は現在の年月をセット
      let reloadCondition = false
      if (!cond.year) {
        cond.year = year.value
        reloadCondition = true
      }

      if (!cond.month) {
        cond.month = month.value
        reloadCondition = true
      }

      // 年月の再設定をした場合、条件を取得し直す
      if (reloadCondition) {
        await whereConditonStore.setItem({
          year: cond.year,
          month: cond.month,
          syuugyouBasyoId: cond.syuugyouBasyoId,
          staffCodes: cond.staffCodes,
          isSoumuNotCheck: cond.isSoumuNotCheck,
          startIndex: cond.startIndex,
          endIndex: cond.endIndex,
        })
        cond = whereConditonStore.searchItem
        // console.log('検索条件（再読み込み後）', cond)
      }

      // 遷移元が派遣先編集画面で、検索結果が保存されている場合
      // 検索条件を設定
      year.value = cond.year! // 前述の年/月再設定を前提の!指定
      month.value = cond.month! // 前述の年/月再設定を前提の!指定
      selectedSyuugyouBasyo.value = cond.syuugyouBasyoId ? cond.syuugyouBasyoId : 0;
      staffCodes.value = cond.staffCodes
      isSoumuNotCheck.value = cond.isSoumuNotCheck
      startIndex.value = cond.startIndex
      endIndex.value = cond.endIndex

      // データが多い場合、全件検索するとエラーが発生するためいずれかの条件が保存されている場合のみ検索を実行
      // （24.3.8 田中さんより／暫定措置）
      if(selectedSyuugyouBasyo.value || staffCodes.value) {
        await searchData()
      }

      isLoading.value = false;
      isInit.value = true;

      nextTick(() => {
        if (myTaskCommonStore.id === null) {
          return
        }
        const scrollTargetUserId = myTaskCommonStore.id
        const id = 'user' + scrollTargetUserId
        const element = document.getElementById(id)
        if (element) {
          element.scrollIntoView({
            behavior: 'instant' as (ScrollBehavior | undefined)
          });
        }
      })
    });

    // 総務の一括確認にチェックをすべて入れる
    const setDakokuCheckAllBySoumu = ((task: MyTaskData) => {
      if (!myTaskList || myTaskList == undefined) {
        return;
      }

      if (!myTaskList.value || myTaskList.value == undefined) {
        return;
      }

      if (!task || typeof task == 'undefined') {
        return;
      }

      if (!task.list || task.list == undefined || task.list == null) {
        return;
      }

      task.list.forEach(item => {
        if (dayjs(item.datetime).isSameOrAfter(dayjs(), 'date')) {
          // 当日以降はチェックを付けない
          return
        }

        if (item.kinmus.length == 0) {
          // 入力が無い場合はチェックを付けない
          return
        }

        for (let i = 0; i < item.kinmus.length; i++) {
          if (item.kinmus[i].isUncomplete) {
            // 入力が完了していない場合はチェックを付けない
            return
          }
        }

        if (!item.check || typeof item.check == 'undefined') {
          return
        }

        if (item.check.length !== 0) {
          return
        }

        item.is_soumu_select = true;
      })

      // for (let i = 0; i < myTaskList.value[key].list!.length; i++) {

      //   if (!myTaskList.value[key].list[i].check || myTaskList.value[key].list[i].check == undefined) {
      //     continue;
      //   }

      //   if (myTaskList.value[key].list[i].check.length !== 0) {
      //     continue;
      //   }
      //   myTaskList.value[key].list[i].is_soumu_select = true;
      // }
    });

    // 日付ソート昇順フラグ
    const sortByDateAscFlg = ref(true);

    // 社員番号ソート昇順フラグ
    const sortBySyainBangouAscFlg = ref(false);

    // 総務チェックソート昇順フラグ
    const sortByIsKakuninAscFlg = ref(false);

    // 日付、就業場所、社員番号で並び替え
    const sortByDate = (() => {
      if (sortByDateAscFlg.value) {
        // 昇順
        sortByDateDesc();
      } else {
        // 降順
        sortByDateAsc();
      }
      sortByDateAscFlg.value = !sortByDateAscFlg.value;

      // 日付ソートした場合は、社員番号ソートを次回用に降順に設定
      sortBySyainBangouAscFlg.value = false;

      sortByIsKakuninAscFlg.value = false;
    });

    // 日付、就業場所、社員番号で並び替え（昇順)
    const sortByDateAsc = (() => {
      if (!myTaskList.value) {
        return
      }
      let tmp = myTaskList.value.sort((a, b) => {

        // 日付で並び替え（昇順)
        if (a.dakoku_date && b.dakoku_date) {
          if (a.dakoku_date > b.dakoku_date) {
            return 1;
          }

          if (a.dakoku_date < b.dakoku_date) {
            return -1;
          }
        }

        // 就業場所で並び替え（昇順)
        if (a.mst_syuugyou_basyo_id > b.mst_syuugyou_basyo_id) {
          return 1;
        };

        if (a.mst_syuugyou_basyo_id < b.mst_syuugyou_basyo_id) {
          return -1;
        };

        // 社員番号で並び替え（昇順)
        if (a.staff_code && b.staff_code) {
          if (a.staff_code > b.staff_code) {
            return 1;
          }

          if (a.staff_code < b.staff_code) {
            return -1;
          }
        }

        return 0;
      });
    });

    // 日付、就業場所、社員番号で並び替え（降順)
    const sortByDateDesc = (() => {
      if (!myTaskList.value) {
        return
      }
      let tmp = myTaskList.value.sort((a, b) => {

        // 日付で並び替え（降順)
        if (a.dakoku_date && b.dakoku_date) {
          if (a.dakoku_date < b.dakoku_date) {
            return 1;
          }

          if (a.dakoku_date > b.dakoku_date) {
            return -1;
          }
        }

        // 就業場所で並び替え（昇順)
        if (a.mst_syuugyou_basyo_id > b.mst_syuugyou_basyo_id) {
          return 1;
        };

        if (a.mst_syuugyou_basyo_id < b.mst_syuugyou_basyo_id) {
          return -1;
        };

        // 社員番号で並び替え（昇順)
        if (a.staff_code && b.staff_code) {
          if (a.staff_code > b.staff_code) {
            return 1;
          }

          if (a.staff_code < b.staff_code) {
            return -1;
          }
        }

        return 0;
      });
    });

    // 社員番号、日付、就業場所で並び替え
    const sortBySyainBangou = (() => {
      if (sortBySyainBangouAscFlg.value) {
        // 昇順
        sortBySyainBangouDesc();
      } else {
        // 降順
        sortBySyainBangouAsc();
      }
      sortBySyainBangouAscFlg.value = !sortBySyainBangouAscFlg.value;

      // 社員番号ソートした場合、日付ソートは次回用に降順に設定
      sortByDateAscFlg.value = false;

      sortByIsKakuninAscFlg.value = false;
    });

    // 社員番号、日付、就業場所で並び替え（昇順)
    const sortBySyainBangouAsc = (() => {
      if (!myTaskList.value) {
        return
      }
      let tmp = myTaskList.value.sort((a, b) => {

        // 社員番号で並び替え（昇順)
        if (a.staff_code && b.staff_code) {
          if (a.staff_code > b.staff_code) {
            return 1;
          }

          if (a.staff_code < b.staff_code) {
            return -1;
          }
        }

        // 日付で並び替え（昇順)
        if (a.dakoku_date && b.dakoku_date) {
          if (a.dakoku_date > b.dakoku_date) {
            return 1;
          }

          if (a.dakoku_date < b.dakoku_date) {
            return -1;
          }
        }

        // 就業場所で並び替え（昇順)
        if (a.mst_syuugyou_basyo_id > b.mst_syuugyou_basyo_id) {
          return 1;
        };

        if (a.mst_syuugyou_basyo_id < b.mst_syuugyou_basyo_id) {
          return -1;
        };

        return 0;
      });
    });

    // 社員番号、日付、就業場所で並び替え（降順)
    const sortBySyainBangouDesc = (() => {
      if (!myTaskList.value) {
        return
      }
      let tmp = myTaskList.value.sort((a, b) => {

        // 社員番号で並び替え（降順)
        if (a.staff_code && b.staff_code) {
          if (a.staff_code < b.staff_code) {
            return 1;
          }

          if (a.staff_code > b.staff_code) {
            return -1;
          }
        }

        // 日付で並び替え（昇順)
        if (a.dakoku_date && b.dakoku_date) {
          if (a.dakoku_date > b.dakoku_date) {
            return 1;
          }

          if (a.dakoku_date < b.dakoku_date) {
            return -1;
          }
        }

        // 就業場所で並び替え（昇順)
        if (a.mst_syuugyou_basyo_id > b.mst_syuugyou_basyo_id) {
          return 1;
        };

        if (a.mst_syuugyou_basyo_id < b.mst_syuugyou_basyo_id) {
          return -1;
        };

        return 0;
      });
    });

    // 総務チェック、日付、就業場所で並び替え
    const sortByIsKakunin = (() => {
      if (sortByIsKakuninAscFlg.value) {
        // 昇順
        sortByIsKakuninAsc();
      } else {
        // 降順
        sortByIsKakuninDesc();
      }
      sortByIsKakuninAscFlg.value = !sortByIsKakuninAscFlg.value;

      // 総務チェックソートした場合、日付ソートは次回用に降順に設定
      sortByDateAscFlg.value = false;

      // 総務チェックソートした場合は、社員番号ソートを次回用に降順に設定
      sortBySyainBangouAscFlg.value = false;
    });

    const sortByIsKakuninAsc = (() => {
      if (!myTaskList.value) {
        return
      }
      let tmp = myTaskList.value.sort((a, b) => {

        // 確認チェックで並び替え（昇順)
        let tmpA = a.is_soumu_select ? 1 : 0;
        let tmpB = b.is_soumu_select ? 1 : 0;

        // if (a.is_soumu_select && b.is_soumu_select) {
        if (tmpA > tmpB) {
          return 1;
        }

        if (tmpA < tmpB) {
          return -1;
        }
        // }

        // 日付で並び替え（昇順)
        if (a.dakoku_date && b.dakoku_date) {
          if (a.dakoku_date > b.dakoku_date) {
            return 1;
          }

          if (a.dakoku_date < b.dakoku_date) {
            return -1;
          }
        }

        // 就業場所で並び替え（昇順)
        if (a.mst_syuugyou_basyo_id > b.mst_syuugyou_basyo_id) {
          return 1;
        };

        if (a.mst_syuugyou_basyo_id < b.mst_syuugyou_basyo_id) {
          return -1;
        };

        return 0;
      });

    });

    const sortByIsKakuninDesc = (() => {
      if (!myTaskList.value) {
        return
      }
      let tmp = myTaskList.value.sort((a, b) => {

        // 確認チェックで並び替え（降順)
        let tmpA = a.is_soumu_select ? 1 : 0;
        let tmpB = b.is_soumu_select ? 1 : 0;

        // if (a.is_soumu_select && b.is_soumu_select) {
        if (tmpA < tmpB) {
          return 1;
        }

        if (tmpA > tmpB) {
          return -1;
        }
        // }

        // 日付で並び替え（昇順)
        if (a.dakoku_date && b.dakoku_date) {
          if (a.dakoku_date > b.dakoku_date) {
            return 1;
          }

          if (a.dakoku_date < b.dakoku_date) {
            return -1;
          }
        }

        // 就業場所で並び替え（昇順)
        if (a.mst_syuugyou_basyo_id > b.mst_syuugyou_basyo_id) {
          return 1;
        };

        if (a.mst_syuugyou_basyo_id < b.mst_syuugyou_basyo_id) {
          return -1;
        };

        return 0;
      });

    });

    // フィルタ変数
    const filter = ref('');

    // 総務が確認の選択した打刻レコードの行数を返す
    const selectItemCountBySoumu = computed(() => {
      if (!myTaskList.value) {
        return
      }
      let selectItemsBySoumu = [];

      for (let i = 0; i < myTaskList.value.length; i++) {
        if (myTaskList.value[i].list.length < 1) {
          continue
        }

        // let tmp = myTaskList.value[i].list.filter((v: any) => v.is_soumu_select == true);
        const soumuSelectedItems = myTaskList.value[i].list.filter((v) => v.is_soumu_select == true);
        if (soumuSelectedItems.length < 1) {
          continue
        }

        selectItemsBySoumu.push(soumuSelectedItems);
      }

      let count = 0;
      if (selectItemsBySoumu.length > 0) {
        for (let j = 0; j < selectItemsBySoumu.length; j++) {
          count += selectItemsBySoumu[j].length;
        }
      }

      return count;
    });

    // 総務チェックを一括登録します。
    const updateCheckListBySoumu = async () => {
      if (!myTaskList.value) {
        return
      }
      const dialogResult = await DialogService.question({
        text: '総務チェックを一括登録しますか？',
        showCancelButton: true,
        confirmButtonText: '登録します',
        cancelButtonText: 'キャンセル',
      })

      if (!dialogResult.isConfirmed) {
        return
      }

      const selectItemsBySoumu: MyTaskSelectItem[] = []

      // 選択された確認を取得
      myTaskList.value.forEach((task) => {
        // let items: SoumuDakokuCheckData[] = task.list.filter((v: any) => v.is_soumu_select == true);
        const soumuSelectedItems = task.list.filter((v) => v.is_soumu_select == true)
        if (soumuSelectedItems.length < 1) {
          return
        }

        const tmp: MyTaskSelectItem = {
          user_id: task.user_id,
          koyou_keiyaku_id: task.koyou_keiyaku_id,
          mst_syuugyou_basyo_id: task.mst_syuugyou_basyo_id,
          check: soumuSelectedItems
        }

        selectItemsBySoumu.push(tmp);
      })

      // パラメータ作成
      const params: SoumuDakokuCheckParams[] = []
      selectItemsBySoumu.forEach(selectItem => {
        const userId = selectItem.user_id;
        const koyouKeiyakuId = selectItem.koyou_keiyaku_id;
        const mstSyuugyouBasyoid = selectItem.mst_syuugyou_basyo_id;

        // 個別のチェック情報分ループ
        selectItem.check.forEach(c => {
          const param: SoumuDakokuCheckParams = {
            user_id: userId,
            koyou_keiyaku_id: koyouKeiyakuId,
            mst_syuugyou_basyo_id: mstSyuugyouBasyoid,
            dakoku_date: c.datetime
          }

          params.push(param);
        })
      })

      const whereCond: SoumuDakokuCheckWhereConditions = {
        year: yearMonthForMonthPicker.value.year,
        month: yearMonthForMonthPicker.value.month + 1,
        mst_syuugyou_basyo_id: selectedSyuugyouBasyo.value,
        staffCodes: staffCodes.value,
        isSoumuNotCheck: isSoumuNotCheck.value,
        userId: null,
        startIndex: startIndex.value,
        endIndex: endIndex.value,
      }

      const request: SoumuDakokuCheckRequest = {
        whereCondition: whereCond,
        params: params
      }

      isLoading.value = true
      if (await updateSoumuChecks(request)) {
        await getDakokuSoumuCheckList(
          {
            year: yearMonthForMonthPicker.value.year,
            month: yearMonthForMonthPicker.value.month + 1,
            mst_syuugyou_basyo_id: selectedSyuugyouBasyo.value,
            staffCodes: staffCodes.value,
            isSoumuNotCheck: isSoumuNotCheck.value,
            userId: null,
            startIndex: startIndex.value,
            endIndex: endIndex.value,
          }
        )
      }
      isLoading.value = false
    }

    // MonthPickerに渡すための年月obj
    const yearMonthForMonthPicker = computed((): MonthPickerModelValue => {
      return {
        year: year.value,
        month: month.value - 1 // プログラム上の月番号と表示上の月名の補正
      }
    })

    // 検索条件で総務打刻確認情報を取得します
    const searchData = (async () => {

      if(startIndex.value != null && endIndex.value != null && (startIndex.value > endIndex.value)){
          DialogService.error({
            title: '開始と終了の範囲指定エラー',
            text: '開始番号が終了番号より大きいです'
          })
          return
      }

      if(startIndex.value != null && startIndex.value < 1){
          DialogService.error({
            title: '開始と終了の範囲指定エラー',
            text: '開始番号は1以上を指定して下さい'
          })
          return
      }

      isLoading.value = true

      const params: SoumuDakokuCheckWhereConditions = {
        year: yearMonthForMonthPicker.value.year,
        month: yearMonthForMonthPicker.value.month + 1,
        mst_syuugyou_basyo_id: selectedSyuugyouBasyo.value,
        staffCodes: staffCodes.value,
        isSoumuNotCheck: isSoumuNotCheck.value,
        userId: null,
        startIndex: startIndex.value,
        endIndex: endIndex.value
      }

      await whereConditonStore.setItem(
        {
          year: yearMonthForMonthPicker.value.year,
          month: yearMonthForMonthPicker.value.month + 1,
          syuugyouBasyoId: selectedSyuugyouBasyo.value,
          staffCodes: staffCodes.value,
          isSoumuNotCheck: isSoumuNotCheck.value,
          startIndex: startIndex.value,
          endIndex: endIndex.value,
        }
      );

      await getDakokuSoumuCheckList(params);

      isLoading.value = false
    });

    // MonthPickerで年月を決定した際に実行
    const changeMonth = async (val: MonthPickerModelValue) => {
      month.value = val.month + 1 // プログラム上の月番号と表示上の月名の補正
      year.value = val.year
    };

    // 検索条件をクリアします
    const clearSearchCondition = (async () => {
      year.value = new Date().getFullYear();
      month.value = new Date().getMonth() + 1;
      selectedSyuugyouBasyo.value = 0;
      staffCodes.value = '';
      isSoumuNotCheck.value = false;
      startIndex.value = 1;
      endIndex.value = 20;
      totalDataCount.value = 0;

      myTaskList.value = [];
      await whereConditonStore.removeItem();
    });

    // 派遣先リストに切り替え
    const changeHakenList = (async (data: MyTaskData) => {
      await myTaskCommonStore.setTargetId(data.user_id)
      await myTaskCommonStore.setTab('soumu-dakoku-check')

      if (data.kintai_summary_id !== null) {
        router.push({
          name: RouterConst.HAKEN_KINMU_LIST, params: {
            kintaiSummaryId: data.kintai_summary_id
          }
        });
      } else {
        router.push({
          name: RouterConst.HAKEN_KINMU_LIST, query: {
            user_id: data.user_id,
            year: year.value,
            month: month.value,
            mst_syuugyou_basyo_id: data.mst_syuugyou_basyo_id,
            koyou_keiyaku_id: data.koyou_keiyaku_id
          }
        });
      }
    });

    // タイムシートへ切り替え
    const changeKinmuList = (async (userId: number, syouninGroupId: number, mstSyuugyouBasyoId: number, koyouKeiyakuId: number) => {
      await myTaskCommonStore.setTargetId(userId)
      await myTaskCommonStore.setTab('soumu-dakoku-check')

      router.push(
        {
          name: RouterConst.KINMU_LIST, query: {
            targetUserId: userId,
            targetSyouninGroupId: syouninGroupId,
            from: RouterConst.MY_TASK,
            year: year.value,
            month: month.value,
            mst_syuugyou_basyo_id: mstSyuugyouBasyoId,
            koyou_keiyaku_id: koyouKeiyakuId,
          }
        }
      );
    });

    // MEDICA_AS-1226 対応
    // 申請を確認するためにクリックした時、ストアに保存する
    const setStoreByClickShinsei = (async (userId: number) => {
      await myTaskCommonStore.setTargetId(userId);
      await myTaskCommonStore.setTab('soumu-dakoku-check');
    });

    return {
      authStore,
      isInit,
      isLoading,
      rows,
      myTaskList,
      dateFormat,
      dateFormatMMDD,
      timeFormat,
      OptionConst,
      Const,
      PermissionConst,
      sortByDate,
      sortBySyainBangou,
      sortByIsKakunin,
      filter,
      selectItemCountBySoumu,
      isUpdating,
      updateCheckListBySoumu,
      updateSoumuChecks,
      setDakokuCheckAllBySoumu,
      searchData,
      whereStartDate,
      whereEndDate,
      whereKana,
      whereSyuugyouBasyo,
      isListLoading,
      isListError,
      getDakokuSoumuCheckList,
      dakokuDetailModalRef: dakokuDetailModal.dakokuDetailModalRef,
      dakokuDetailModalParts: dakokuDetailModal.dakokuDetailModalParts,
      detailData: dakokuDetailModal.detailData,
      yearMonthForMonthPicker,
      changeMonth,
      timeToHHmm,
      dakokuSyouninStatus,
      selectedSyuugyouBasyo,
      syuugyouBasyoOptions,
      clearSearchCondition,
      staffCodes,
      isSoumuNotCheck,
      changeHakenList,
      changeKinmuList,
      setStoreByClickShinsei,
      startIndex,
      endIndex,
      totalDataCount,
    }
  },
  components: {
    'dialog-dakoku-detail': DakokuDetail,
    'shinseis-title': ShinseisTitle,
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/mytask-soumu-check-list.scss';
</style>
